export const FEATURE_NOT_AVAILABLE_INTERACTION = 'na'

const FEATURE_AVAILABLE_INTERACTIONS = {
  RESERVATION: 'reservation',
  TRANSACTION: 'transaction',
  C2B: 'c2b'
}

export const getUrlInfo = url => {
  const urlObj = new URL(url)
  const paramsObj = new URLSearchParams(urlObj.search)
  return {urlObj, paramsObj}
}

export const getInteractionId = url => {
  const {urlObj, paramsObj} = getUrlInfo(url)
  const pathname = urlObj.pathname
  const action = paramsObj.get('action')

  const interaction = pathname.split('/')[1]
  const userType = pathname.split('/')[2]
  const interactionId = `${interaction}-${userType}-${action}`

  return Object.values(FEATURE_AVAILABLE_INTERACTIONS).includes(interaction)
    ? interactionId
    : FEATURE_NOT_AVAILABLE_INTERACTION
}

export const RESERVATION_ACCEPT_TYPE = 'reservationAccept'
export const LEGAL_CONDITIONS_TYPE = 'legalConditions'
export const REDIRECT_TO_RAPID_PAY_TYPE = 'redirectToRapidPay'
export const GENERAL_ERROR_TYPE = 'error'
export const USER_STOPPED_EXECUTION_ERROR = 'Execution stopped by user'
